export type GraphMode = 'family' | 'species';

interface GraphModeToggleProps {
  mode: GraphMode;
  onChange(m: GraphMode): void;
}

const MODES: Array<{ id: GraphMode; label: string }> = [
  { id: 'family', label: 'Families' },
  { id: 'species', label: 'Species' },
];

export function GraphModeToggle({ mode, onChange }: GraphModeToggleProps): JSX.Element {
  return (
    <div role="tablist" className="flex gap-1 rounded-md border border-bark-300 bg-paper-50 p-1">
      {MODES.map(m => (
        <button
          key={m.id}
          role="tab"
          aria-selected={mode === m.id}
          onClick={() => onChange(m.id)}
          className={`rounded px-3 py-1 font-body text-xs ${
            mode === m.id ? 'bg-sage-700 text-paper-50' : 'text-ink-600 hover:bg-paper-100'
          }`}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}
